export const findFeatureLabel = function (features, input) {
  if (features === null) {
    return;
  }

  const categoryMatch =
    features.find((categoryData) => categoryData.category === input) || null;

  if (categoryMatch !== null) {
    return categoryMatch.category;
  }

  const featureMatch = features
    .flatMap((categoryData) => categoryData.features)
    .find((featureData) => featureData.id === input);

  return featureMatch ? featureMatch.label : null;
};
